import { useState } from "react";
import { Link } from "react-router-dom";

const TabData = [
    "Real estate",
    "New homes",
    "Popular areas",
    "Popular searches",
];


const tabContent = {
    "Real estate": (
        <>
            <h3 className="font-light my-6 !text-[#3D3B40]">Real estate in Nigeria</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-[#726E75]">
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/lagos" className="underline cursor-pointer">Real estate Lagos</Link>
                    <Link to="/buy/searched/abuja" className="underline cursor-pointer">Real estate Abuja</Link>
                    <Link to="/buy/searched/port-harcourt" className="underline cursor-pointer">Real estate Port Harcourt</Link>
                    <Link to="/buy/searched/enugu" className="underline cursor-pointer">Real estate Enugu</Link>
                    <Link to="/buy/searched/ibadan" className="underline cursor-pointer">Real estate Ibadan</Link>
                    <Link to="/buy/searched/benin-city" className="underline cursor-pointer">Real estate Benin City</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/kano" className="underline cursor-pointer">Real estate Kano</Link>
                    <Link to="/buy/searched/kaduna" className="underline cursor-pointer">Real estate Kaduna</Link>
                    <Link to="/buy/searched/uyo" className="underline cursor-pointer">Real estate Uyo</Link>
                    <Link to="/buy/searched/warri" className="underline cursor-pointer">Real estate Warri</Link>
                    <Link to="/buy/searched/calabar" className="underline cursor-pointer">Real estate Calabar</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/owerri" className="underline cursor-pointer">Real estate Owerri</Link>
                    <Link to="/buy/searched/abeokuta" className="underline cursor-pointer">Real estate Abeokuta</Link>
                    <Link to="/buy/searched/jos" className="underline cursor-pointer">Real estate Jos</Link>
                    <Link to="/buy/searched/ilorin" className="underline cursor-pointer">Real estate Ilorin</Link>
                    <Link to="/buy/searched/asaba" className="underline cursor-pointer">Real estate Asaba</Link>
                </div>
            </div>
        </>
    ),
    "New homes": (
        <>
            <h3 className="font-light my-6 !text-[#3D3B40]">Build new homes in Nigeria</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-[#726E75]">
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/lagos" className="underline cursor-pointer">Home builders Lagos</Link>
                    <Link to="/buy/searched/abuja" className="underline cursor-pointer">House and land Abuja</Link>
                    <Link to="/buy/searched/port-harcourt" className="underline cursor-pointer">Home builders Port Harcourt</Link>
                    <Link to="/buy/searched/ibadan" className="underline cursor-pointer">House and land Ibadan</Link>
                    <Link to="/buy/searched/benin-city" className="underline cursor-pointer">New homes in Benin City</Link>
                    <Link to="/buy/searched/enugu" className="underline cursor-pointer">Home builders Enugu</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/nigeria" className="underline cursor-pointer">House designs Nigeria</Link>
                    <Link to="/buy/searched/abuja" className="underline cursor-pointer">Land for sale Abuja</Link>
                    <Link to="/buy/searched/lagos" className="underline cursor-pointer">Affordable homes Lagos</Link>
                    <Link to="/buy/searched/lekki" className="underline cursor-pointer">Luxury homes Lekki</Link>
                    <Link to="/buy/searched/ogun" className="underline cursor-pointer">New developments Ogun</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/nigeria" className="underline cursor-pointer">Duplex designs Nigeria</Link>
                    <Link to="/buy/searched/kaduna" className="underline cursor-pointer">Home builders Kaduna</Link>
                    <Link to="/buy/searched/owerri" className="underline cursor-pointer">House and land Owerri</Link>
                    <Link to="/buy/searched/asaba" className="underline cursor-pointer">Modern homes Asaba</Link>
                    <Link to="/buy/searched/jos" className="underline cursor-pointer">Real estate projects Jos</Link>
                </div>
            </div>
        </>
    ),
    "Popular areas": (
        <>
            <h3 className="font-light my-6 !text-[#3D3B40]">Browse popular areas in Nigeria</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-[#726E75]">
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/lekki" className="underline cursor-pointer">Lekki property prices</Link>
                    <Link to="/buy/searched/ajah" className="underline cursor-pointer">Ajah property prices</Link>
                    <Link to="/buy/searched/maitama" className="underline cursor-pointer">Maitama house prices</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/banana-island" className="underline cursor-pointer">Banana Island prices</Link>
                    <Link to="/buy/searched/gwarinpa" className="underline cursor-pointer">Gwarinpa property values</Link>
                    <Link to="/buy/searched/lagos" className="underline cursor-pointer">Suburb profiles Lagos</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/ikoyi" className="underline cursor-pointer">Ikoyi house prices</Link>
                    <Link to="/buy/searched/asokoro" className="underline cursor-pointer">Asokoro real estate</Link>
                </div>
            </div>
        </>
    ),
    "Popular searches": (
        <>
            <h3 className="font-light my-6 !text-[#3D3B40]">Browse popular property searches</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-[#726E75]">
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/news" className="underline cursor-pointer">Nigeria property news</Link>
                    <Link to="/buy/searched/mortgage" className="underline cursor-pointer">Mortgage calculator Nigeria</Link>
                    <Link to="/buy/searched/sell" className="underline cursor-pointer">Selling property in Lagos</Link>
                    <Link to="/buy/searched/rent-to-own" className="underline cursor-pointer">Rent to own</Link>
                    <Link to="/buy/searched/documentation" className="underline cursor-pointer">Land documentation guide</Link>
                    <Link to="/buy/searched/trends" className="underline cursor-pointer">Property trends 2025</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/investing" className="underline cursor-pointer">Investing in real estate Nigeria</Link>
                    <Link to="/buy/searched/how-to-buy" className="underline cursor-pointer">How to buy land in Nigeria</Link>
                    <Link to="/buy/searched/building-cost" className="underline cursor-pointer">Cost of building in Nigeria</Link>
                    <Link to="/buy/searched/land-use-act" className="underline cursor-pointer">Land Use Act explained</Link>
                    <Link to="/buy/searched/property-laws" className="underline cursor-pointer">Nigerian property laws</Link>
                </div>
                <div className="flex flex-col gap-4">
                    <Link to="/buy/searched/stamp-duty" className="underline cursor-pointer">Stamp duty rates Nigeria</Link>
                    <Link to="/buy/searched/loan-options" className="underline cursor-pointer">Housing loan options</Link>
                    <Link to="/buy/searched/borrowing" className="underline cursor-pointer">How much can I borrow Nigeria</Link>
                    <Link to="/buy/searched/influencers" className="underline cursor-pointer">Real estate influencers</Link>
                    <Link to="/buy/searched/forecast" className="underline cursor-pointer">2025 real estate forecast</Link>
                </div>
            </div>
        </>
    ),
};



const FooterTabbing = () => {
    const [activeTab, setActiveTab] = useState(TabData[0]);

    const ActiveTab =
        "bg-[#FFEAEF] border-b-[#E5002A] rounded-t-lg text-[#404040] font-semibold";
    const NormalTab =
        "w-full  grid place-items-center  whitespace-nowrap text-[#737373] font-medium text-sm md:text-sm lg:text-base border border-b-2 border-transparent hover:border-b-[#E5002A] py-3 px-10 ease-in-out duration-700 cursor-pointer";

    return (
        <div className="bg-white rounded-xl p-4 mt-5 mb-10 relative z-50 container mx-auto max-w-6xl">
            <div className="w-full  border-b border-[#E5E5E5] grid grid-flow-col place-items-start overflow-x-scroll scrollBarHidden">
                {TabData.map((tab, index) => (
                    <div
                        key={index}
                        className={`${NormalTab} ${activeTab === tab ? ActiveTab : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </div>
                ))}
            </div>
            <div>{tabContent[activeTab]}</div>
        </div>
    );
}

export default FooterTabbing